var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notfound"}},[_c('img',{attrs:{"src":require("@/assets/404_image.png"),"alt":"","srcset":""}}),_c('h1',[_vm._v("页面不存在")]),_c('h2',[_vm._v("啊哦，出错了，页面丢失了")]),_c('button',{on:{"click":_vm.goHome}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }